// removed by extract-text-webpack-plugin
module.exports = {"item":"_1dEYQSmW3b0XAXOKEws22Y","item-selected":"cKSB1jreIrNwTpP3fbtfi","item-reversed":"_2QQBsbdbnNHdfv83zhBv_G","icon":"_1ydiTJv7TmRriY_B0g45HV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SortableTableHeadItem.less
 ** module id = 857
 ** module chunks = 0
 **/